import React from 'react';

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Typography from '@mui/material/Typography';

import Container from '@ui/Container';
import Link from '@ui/link/Link';
import PageTitle from '@ui/PageTitle';

import useCms from '@components/Cms/useCms';

const faqItems = [
    {
        question: 'Mik a podcastok leadási paraméterei?',
        answer: 'Kizárólag jó hangminőségű, háttérzaj-mentes anyagokat tudunk befogadni, Mp3, 320 bit formátumban.',
    },
    {
        question: 'Megadhatom podcastom RSS feed-jét, hogy felkerüljön a Atalon-ra?',
        answer: 'Nem, erre nincs lehetőség.',
    },
    {
        question: 'Be tudom ágyazni az Atalon lejátszót a honlapomra? Használhatom az Atalon RSS feed-jét?',
        answer: 'Igen, epizódonként a megosztás ikonra kattintva elérheted a másolható kódot.',
    },
    {
        question: 'Hogyan jutok elérési adatokhoz?',
        answer: 'A Gemius Prism független mérőfelületen keresztül hívjuk le az adatokat, melyeket kérésre megosztjuk a podcasterekkel.',
    },
    {
        question: 'Milyen szempontok alapján történik a díjazás?',
        answer: 'Kerüljük a napi aktualitás köré épülő témákat, megosztó nézeteket ábrázoló anyagokat. Összetett szempontrendszer mentén rangsorolunk. Kulcsfontosságú a jelentés nívója, a stílus, hitelesség, aminek fogyasztói szemmel mércéje lehet akár a követőtábor is. Ezt alárendeljük a minőségnek, de mégis elválaszthatatlan része a rangsorolásnak.',
    },
    {
        question: 'Hogy működik az elszámolás?',
        answer: 'Amennyiben a podcaster jogosulttá válik díjazásra, úgy erről e-mail üzenetben értesítjük. A podcaster és az ATMEDIA között kifejezetten erre vonatkozóan létrejött külön megállapodás alapján, a számla kézhezvételét követő 30 (harminc) napon belül vállal kötelzettséget. Felhasználó az ÁSZF elfogadásával tudomásul veszi és elfogadja, hogy a Podcaster ösztönzőprogram keretében ATMEDIA az 5.3.2. pont szerint kizárólag olyan számlaképes vállalkozások részére teljesít kifizetést, mely vállalkozások nyilvántartás szerinti tevékenységi körében szerepel a film-, video-, televízióműsor gyártás (TEÁOR 5911).',
    },
    {
        question: 'Podcasterként milyen online hirdetési felületekhez juthatok?',
        answer: (
            <>
                Részletekért fordulj kollégáinkhoz, eléred őket az{' '}
                <Link href="mailto:onlinesales@atmedia.hu">onlinesales@atmedia.hu</Link> email címen.
            </>
        ),
    },
];

const PodcasterFaqPage = () => {
    const cms = useCms();
    return (
        <Container maxWidth="md" sx={{ p: 0 }}>
            <PageTitle>{cms[1058]}</PageTitle>

            {faqItems.map((item, index) => (
                <Accordion key={index}>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls={`faq-item-${index}`}
                        id={`faq-item-${index}-header`}
                    >
                        <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>
                            {item.question}
                        </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Typography>{item.answer}</Typography>
                    </AccordionDetails>
                </Accordion>
            ))}
        </Container>
    );
};

export default PodcasterFaqPage;
